var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"main-button",style:({ backgroundImage: ("url(" + _vm.buttonImage + ")") }),on:{"click":_vm.buttonClickHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }